import { Dispatch } from 'redux'
import { clearError } from 'core/modules/error'

export function callClearError() {
  return (dispatch: Dispatch) => {
    dispatch(clearError())
  }
}
